import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../services/api';

// Vanity store URL: /store/:slug -> /vendor/:id
export default function StoreSlugRedirect() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/vendors/by-slug/${slug}`)
      .then((r) => nav(`/vendor/${r.data.id}`, { replace: true }))
      .catch(() => setErr('Store not found'));
  }, [slug, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center text-slate-400" data-testid="store-slug-redirect">
      {err || 'Opening store…'}
    </div>
  );
}
